// Neu nach docs/mockup/src.js `Kopf`, Aufbau wie /opt/webgis/frontend/src/app/TopNav.tsx
// (SPEC 03 §7.2.1). Links → rechts: Wortmarke · Hand-Kachel · „Handschrift“ · Verfahren ·
// Hauptnavigation · Suche · Aufträge · Thema · Konto. ≤ 859 px 52 px hoch, ohne Navigation und Suche (die
// Reiterleiste übernimmt, samt „Suchen“).
// Geändert (01.10.): der Suchknopf öffnet die Befehlssuche (Seiten, Werkzeuge, Codes, Text, KI) statt
// nur zur Fragebar der Auswertung zu springen.
import { Link, useLocation } from "react-router-dom";
import type { Ich } from "../../api/typen";
import { Icon, IconBtn } from "../ui";
import { useTheme } from "../../lib/theme";
import { TX } from "../../lib/texte";
import { Auftraege, AuftraegeLinie } from "./Auftraege";
import { AvatarMenu } from "./AvatarMenu";
import { Logo } from "./Logo";
import { oeffneBefehlssuche } from "./Befehlssuche";
import { navZiele } from "./navigation";
import { VerfahrenWahl } from "./VerfahrenWahl";

export function TopNav({ V, ich }: { V: string | null; ich: Ich | undefined }) {
  const { thema, umschalten } = useTheme();
  const { pathname } = useLocation();
  const dunkel = thema === "dark";

  return (
    <header className="kopf glass">
      <Link to={V ? `/v/${encodeURIComponent(V)}/auswerten` : "/"} className="marke ring-focus" aria-label="Handschrift – zur Auswertung">
        <Logo className="logo logo-kopf" />
        <span className="marke-kachel" aria-hidden="true">
          <Icon name="hand-waving" size={17} />
        </span>
        <span className="marke-name disp">{TX.allgemein.produkt}</span>
      </Link>
      <VerfahrenWahl V={V} />
      <nav className="nav" aria-label={TX.shell.nav}>
        {navZiele(V, ich).map((z) => {
          const an = z.an.test(pathname);
          return (
            <Link key={z.id} to={z.zu} className={`navpill ring-focus${an ? " on" : ""}${z.schmal ? " np-schmal" : ""}`} aria-current={an ? "page" : undefined} aria-label={z.text} title={z.text}>
              <Icon name={z.icon} size={16} />
              <span className="nl">{z.text}</span>
            </Link>
          );
        })}
      </nav>
      <div className="kopf-rechts">
        <button
          type="button"
          className="suchknopf ring-focus"
          onClick={oeffneBefehlssuche}
          aria-label={TX.shell.suchen}
          aria-haspopup="dialog"
          aria-keyshortcuts="F Control+K Meta+K"
          title={TX.befehle.knopfTitel}
        >
          <Icon name="magnifying-glass" size={15} />
          <span className="sk-text">{TX.shell.suchen}</span>
          <span className="kbd">F</span>
        </button>
        <Auftraege V={V} />
        {/* ≤ 559 px ausgeblendet (Platz für den Aufträge-Knopf) — dort steht es im Kontomenü. */}
        <IconBtn type="button" className="kopf-thema" icon={dunkel ? "sun" : "moon"} title={dunkel ? TX.shell.hell : TX.shell.dunkel} onClick={umschalten} />
        {ich && <AvatarMenu ich={ich} />}
      </div>
      <AuftraegeLinie V={V} />
    </header>
  );
}
